'use client'; // Error components must be Client Components

import { clearWorkerDevice } from '@app-worker/shared/workerDevice/clearWorkerDevice/clearWorkerDevice';
import { WorkerPages } from '@repo/features/workerPages';
import { navAndReload } from '@repo/libs/navAndReload';
import { Alert } from '@repo/features/Alert';
import { Button } from '@repo/features/Button';
import { SnowAndLandLogoSvg } from '@repo/features/SnowAndLandLogoSvg';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const handleLogout = async () => {
    await clearWorkerDevice();
    navAndReload(WorkerPages.Login);
  };

  const handleReset = () => {
    reset();
  };

  return (
    <div className='flex min-h-screen flex-col items-center justify-center p-6'>
      <div className='flex w-full max-w-[400px] flex-col items-center gap-6'>
        <div className='text-secondary'>
          <SnowAndLandLogoSvg size={64} />
        </div>
        <h5 className='m-0 text-center text-2xl font-bold'>
          We are sorry, something went wrong
        </h5>
        <span className='text-center text-sm text-muted-foreground'>
          Please refresh the page. If after 5 seconds, you still see this error,
          please reach out to an admin
        </span>
        <Alert color='error' className='w-full'>
          {error.message}
        </Alert>
        <div className='flex w-full gap-4'>
          <Button className='w-full' variant='solid' onClick={handleReset}>
            Reload
          </Button>
          <Button className='w-full' variant='outline' onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
}
